import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { OperationStatusCode } from '@killer-party/contracts';
import { agentCounts } from '../../domain/agent-counts';
import { agentName } from '../../domain/format';
import { apiErrorMessage, apiErrorStatus } from '../../services/api-error';
import { reloadEvery } from '../../services/polling';
import { PublicOperationService } from '../../services/public-operation.service';
import { Countdown } from '../../shared/countdown/countdown';
import { Dossier } from '../../shared/dossier/dossier';
import { GameStatus } from '../../shared/game-status/game-status';
import { PageTitle } from '../../shared/page-title/page-title';
import { RankingTable } from '../../shared/ranking-table/ranking-table';
import { StatePanel } from '../../shared/state-panel/state-panel';

const STATUS: Partial<Record<OperationStatusCode, string>> = {
  VALIDATED: 'En attente',
  STARTED: 'En cours',
  COMPLETE: 'Terminée',
};

// Page publique d'une operation : statut et classement (TD-016), prenoms et noms de code (TD-029).
@Component({
  selector: 'app-public-operation-page',
  imports: [
    Countdown,
    DatePipe,
    Dossier,
    GameStatus,
    PageTitle,
    RankingTable,
    RouterLink,
    StatePanel,
  ],
  templateUrl: './public-operation-page.html',
})
export class PublicOperationPage {
  readonly operationId = input.required<string>();

  protected readonly operation = inject(PublicOperationService).operation(() => this.operationId());
  protected readonly agentName = agentName;
  protected readonly counts = computed(() => agentCounts(this.operation.value()?.ranking ?? []));
  protected readonly status = computed(
    () => STATUS[this.operation.value()?.statusCode ?? 'STARTED'] ?? '',
  );
  protected readonly notFound = computed(() => apiErrorStatus(this.operation.error()) === 404);
  protected readonly loadError = computed(() =>
    this.operation.error() && !this.notFound() ? apiErrorMessage(this.operation.error()) : null,
  );

  constructor() {
    reloadEvery(this.operation, 15_000);
  }
}
